/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFeedbackSubmissionCreation
 */
export interface APIFeedbackSubmissionCreation {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof APIFeedbackSubmissionCreation
     */
    submission: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackSubmissionCreation
     */
    article: string;
}

/**
 * Check if a given object implements the APIFeedbackSubmissionCreation interface.
 */
export function instanceOfAPIFeedbackSubmissionCreation(value: object): value is APIFeedbackSubmissionCreation {
    if (!('submission' in value) || value['submission'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    return true;
}

export function APIFeedbackSubmissionCreationFromJSON(json: any): APIFeedbackSubmissionCreation {
    return APIFeedbackSubmissionCreationFromJSONTyped(json, false);
}

export function APIFeedbackSubmissionCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackSubmissionCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'submission': json['submission'],
        'article': json['article'],
    };
}

export function APIFeedbackSubmissionCreationToJSON(value?: APIFeedbackSubmissionCreation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'submission': value['submission'],
        'article': value['article'],
    };
}

